import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e352a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PaginationArrow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  class: "wrap",
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAVFBMVEUAAABZWVlZWVlZWVlZWVlYWFhZWVlZWVlaWlpcXFxVVVVWVlZ/f39YWFhYWFhKSkpYWFhaWlpaWlpZWVlZWVlZWVlYWFhYWFhZWVlZWVlZWVlZWVkCne91AAAAG3RSTlMA87D77d/TvmYhGAwCiTQGmVVBbSxeOceBeRRZ9j3bAAAAbklEQVRIx+2NxxGAMBADRTY5GRPcf59wrkBm4Hf7lnZB0a3FfoGnrrz3BgCrT559YqP0vhxYvRF91o+qV73qv9LDBv0xguUU/woem8ujb0HTpPIoFvDMITJpRCMa+SPiwLNJJHOIjBjEsJVpi3fcvKQZfBFOJSYAAAAASUVORK5CYII="
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "PaginationArrow-num" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "PaginationArrow-interval" }, " / ", -1))
const _hoisted_6 = { class: "PaginationArrow-num" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  class: "wrap",
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAP1BMVEUAAABaWlpZWVlZWVlYWFhYWFhWVlZaWlpZWVlcXFxZWVlZWVlXV1dXV1dbW1tYWFhZWVlaWlpaWlpZWVlZWVkeLilFAAAAFHRSTlMAd/bqmlQU4c0m+cVGLA6quqhvh8p8+7UAAABlSURBVEjH7Za5EcAgDAR5hIx/wOq/VqNxA9yMAwJdvNpN5b61UFaHLIqEhhxU6duRiN+kRzxwcWaLWMQiE0UIuOBFG+P8obw8o/hFiseE6W82velN/5veFeUrI7+G6oGlTIAe2gvmGhJOU7tqkAAAAABJRU5ErkJggg=="
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]




export default /*#__PURE__*/_defineComponent({
  props: {
  currentPage: {
    type: Number,
    default: 1
  },
  pages: {
    type: Number,
    default: 1
  }
},
  emits: ['update:currentPage'],
  setup(__props, { emit: emits }) {

const props = __props




// 分页切换
const pageChange = (page: number) => {
  if (page < 1 || page > props.pages) {
    return
  }
  console.log(page)
  emits('update:currentPage', page)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "PaginationArrow-left icon tstnc",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (pageChange(__props.currentPage - 1)))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(__props.currentPage), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.pages), 1),
    _createElementVNode("div", {
      class: "PaginationArrow-right icon tstnc",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (pageChange(__props.currentPage + 1)))
    }, _hoisted_8)
  ]))
}
}

})